// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --ts-primary: #BEA781;
  --ts-black: #000000;
  --ts-grey: #7B7B7B;
  --ts-white: #FFFFFF;
  --ts-red: #E8502F;
  --ts-green: #9DAA45;
  /* App background surface (light) */
  --ts-app-bg: #FBFDFC;
}
`, "",{"version":3,"sources":["webpack://./src/theme/default.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,mCAAmC;EACnC,oBAAoB;AACtB","sourcesContent":[":root {\n  --ts-primary: #BEA781;\n  --ts-black: #000000;\n  --ts-grey: #7B7B7B;\n  --ts-white: #FFFFFF;\n  --ts-red: #E8502F;\n  --ts-green: #9DAA45;\n  /* App background surface (light) */\n  --ts-app-bg: #FBFDFC;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
